import React from "react";

export default function Hotel() {
  return (
    <div style={{ padding: "2rem", maxWidth: "800px", margin: "0 auto" }}>
      <h2 style={{ marginBottom: "1.5rem" }}>Informasjon</h2>

      <img
        src="img/sheraton.png"
        alt="Sheraton Sopot"
        style={{
          width: "100%",
          borderRadius: "10px",
          marginBottom: "1.5rem",
          boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
        }}
      />

      <h3>Sheraton Sopot Hotel</h3>
      <p style={{ marginBottom: "0.5rem" }}>
        Powstańców Warszawy 10, 81-718 Sopot, Polen
      </p>
      <p style={{ marginBottom: "1rem" }}>
        <a
          href="https://www.google.com/maps?rlz=1C1VDKB_noNO1080NO1080&gs_lcrp=EgZjaHJvbWUyBggAEEUYOTIWCAEQLhivARjHARiABBiYBRiZBRieBTIHCAIQABiABDIICAMQABgWGB4yCAgEEAAYFhgeMggIBRAAGBYYHjIICAYQABgWGB4yCAgHEAAYFhgeMggICBAAGBYYHjIICAkQABgWGB7SAQgyODQyajBqN6gCALACAA&um=1&ie=UTF-8&fb=1&gl=no&sa=X&geocode=KYOp92OOCv1GMfX3VWlDctag&daddr=Powsta%C5%84c%C3%B3w+Warszawy+10,+81-718+Sopot,+Polen"
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: "#002d72", textDecoration: "underline" }}
        >
          📍 Vis på Google Maps
        </a>
      </p>

      <h4>🕑 Innsjekk og utsjekk</h4>
      <ul>
        <li>Innsjekk: fra ca. kl. 16:00 torsdag</li>
        <li>Utsjekk: innen kl. 12:00 søndag</li>
      </ul>

      <h4>🍽️ Frokost</h4>
      <p>
        Frokost serveres i hotellets restaurant hver morgen fra kl. 07:00 til 10:00.
        
      </p>

      <h4>🏖️ Fasiliteter</h4>
      <ul>
        <li>Spa og wellness-avdeling</li>
        <li>Innendørs basseng og badstue</li>
        <li>Bar og loungeområde</li>
        <li>Strandpromenade rett utenfor hotellet</li>
        <li>Heis og tilgjengelighet for alle</li>
      </ul>
      <h4>👕🩳 Kleskode</h4>
      <ul>
        <li>Kleskoden er fritidsklær som passer til været, reisefølge og program ☀️
        NB! Vi vil ha en fin middag på kvelden lørdag 30. august og her oppfordres alle til å stille i pene sommerklær. 
        </li>
      </ul>
    </div>
  );
}
